/*
Name		: quizPage.jsx
Created By	: Stephen Amey
Date		: May 16, 2018
----------------------------------------------------------------------------------------------------------------------------------------
Description	: 
	Quiz page containing a header and the quiz body(quizBody.jsx, which contains the quiz itself)
----------------------------------------------------------------------------------------------------------------------------------------
Modification history (- Name, Date : Changes) :


*/

import React from 'react';
import Header from './header.jsx';
import QuizBody from './quizBody.jsx';
import '../CSS/econ.css';

export default class quizBody extends React.Component{
	render() {
		return (
			<div className="appBody">
				<Header />
				<QuizBody />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Components/quizPage.jsx